import React from "react";

import { ThemedSelect } from "../../../components/common/ThemedSelect";
import {
  TICK_CADENCE_OPTIONS,
  type ConnectionStatus,
  type TickCadence,
} from "./marketMonitorLiveClient";

interface TickCadenceSelectProps {
  value: TickCadence;
  onChange: (next: TickCadence) => void;
  status: ConnectionStatus;
  disabled?: boolean;
}

const statusLabel = (status: ConnectionStatus): string => {
  switch (status) {
    case "open":
      return "live";
    case "connecting":
      return "connecting…";
    case "reconnecting":
      return "reconnecting…";
    case "closed":
      return "offline";
    default:
      return "idle";
  }
};

export const TickCadenceSelect: React.FC<TickCadenceSelectProps> = ({
  value,
  onChange,
  status,
  disabled = false,
}) => {
  return (
    <div
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: 8,
        fontSize: 13,
      }}
    >
      <span aria-hidden="true">Tick Frequency</span>
      <div style={{ minWidth: 110 }}>
        <ThemedSelect<TickCadence>
          value={value}
          options={TICK_CADENCE_OPTIONS}
          onChange={onChange}
          disabled={disabled}
          ariaLabel="Tick frequency"
          testId="market-monitor-cadence-select"
        />
      </div>
      <span
        title={`live stream: ${statusLabel(status)}`}
        style={{
          fontSize: 11,
          opacity: 0.65,
        }}
      >
        {statusLabel(status)}
      </span>
    </div>
  );
};
